import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    cta: {
        id: '_.loan_builder.cta',
        defaultMessage: 'Continue with{amount}'
    },
    CTAinfo: {
        id: '_.loan_builder.cta_info_text',
        defaultMessage:
            'Before we can send funds to your account, we need you to complete a few final steps. Click "Continue" to get started.'
    },
    continueError: {
        id: '_.loan_builder.continue_error',
        defaultMessage: 'Choose an option above to continue'
    },
    earlyRepaymentCalculatorError: {
        id: '_.loan_builder.early_repayment_calculator_error',
        defaultMessage:
            'Select an offer option above to see how it looks if you repay early'
    }
});
